import { render } from "./edit_promotion_form.vue?vue&type=template&id=5f0304d6&scoped=true"
import script from "./edit_promotion_form.vue?vue&type=script&lang=js"
export * from "./edit_promotion_form.vue?vue&type=script&lang=js"

import "./edit_promotion_form.vue?vue&type=style&index=0&id=5f0304d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0304d6"]])

export default __exports__